module.exports = "static/assets/cb3df62e2918eb7e01459b3efacff619.png";